import { useEffect, useMemo } from "react";
import logoGoldsand from "@/assets/logo-goldsand-v2.png";
import { getMobilePlatform } from "@/utils/webview";
import { APPSTORE_LINK, PLAYSTORE_LINK } from "@/constants";

// Deliberate dwell so the interstitial reads as an intentional step rather than
// a jarring flash before the store redirect.
const REDIRECT_DELAY_MS = 3000;

// This page is only reached when the /app/auth/invite-code universal link was NOT
// intercepted by the native app — i.e. the app isn't installed (or we're on
// desktop). In that case, send the visitor to the right store to install Goldsand.
function storeTarget() {
  switch (getMobilePlatform()) {
    case "ios":
      return { href: APPSTORE_LINK, label: "the App Store" };
    case "android":
      return { href: PLAYSTORE_LINK, label: "Google Play" };
    default:
      return { href: "/download", label: "the download page" };
  }
}

export default function AuthInviteCode() {
  const { href, label } = useMemo(storeTarget, []);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      window.location.replace(href);
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timeoutId);
  }, [href]);

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background text-foreground px-lg">
      <div className="max-w-[420px] w-full flex flex-col items-center text-center gap-md">
        <img
          src={logoGoldsand}
          alt="Goldsand logo"
          className="h-[120px] rounded-[16px] object-cover"
        />
        <div className="flex items-center gap-sm">
          <span className="w-[18px] h-[18px] rounded-full border-2 border-border border-t-accent animate-spin" />
          <h1 className="text-lg font-bold">Getting Goldsand…</h1>
        </div>
        <p className="text-base text-muted-fg leading-relaxed">
          Taking you to {label} to install the app. If you&apos;re not redirected
          automatically, tap below.
        </p>
        <a
          href={href}
          className="btn-primary mt-xs h-[48px] px-[32px] rounded-full bg-foreground text-primary-fg text-base font-semibold inline-flex items-center justify-center cursor-pointer shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
        >
          Download Goldsand
        </a>
      </div>
    </div>
  );
}
